/**
 * Черновики, у которых идёт «Создать проект»: проект уже показан созданным (плашки нет), а запрос ждёт сохранений полей
 * и уходит в фоне. Пока отметка стоит, ответ сохранения поля и realtime-эхо (они ещё черновик) не возвращают плашку.
 */
const publishing = new Set<string>();

/** Ставит отметку; false — публикация этого черновика уже идёт (второе нажатие) */
export function startDraftPublishing(projectId: string): boolean {
  if (publishing.has(projectId)) return false;
  publishing.add(projectId);
  return true;
}

export function finishDraftPublishing(projectId: string): void {
  publishing.delete(projectId);
}

export function isDraftPublishing(projectId: string): boolean {
  return publishing.has(projectId);
}
